import React             from 'react';
import classnames        from 'classnames';
import { Modal }         from 'react-bootstrap';
import ErrorLabel        from 'pu-react/components/base/ErrorLabel';

const UploadTxtBtn = () => {
  return(
    <span>
      <i className="far fa-folder-open"></i> 
      &nbsp;
      BROWSE FILE 
    </span>
  )
}

const LoadingTxtBtn = () => {
  return(
    <span>
      <span className="spinner-border spinner-border-sm" 
       role="status" aria-hidden="true"></span> 
      &nbsp;
      Loading...
    </span>
  )
}

export default (props) => {
  let txt_button;
  if (props.loading) {
    txt_button = <LoadingTxtBtn />;
  } else {
    txt_button = <UploadTxtBtn />;
  }

  return (
    <div className="btn-upload-bom file-input">
      <div className="btn btn-orange">
        {txt_button}
        <input
          type="file"
          className="parts-input"
          multiple
          name="file"
          value={props.bom_file_name}
          onChange={e => props.onUploadBomFile(e.target.files[0])} 
          disabled={props.loading}
          />
      </div>
      <div className="file-name">
        {props.bom_file_name}
      </div>
      <ErrorLabel error={props.error} />
    </div>
  );
};
